import React, { Component } from 'react'
import AddTitleBar from '../../../../components/titleBar/add_titleBar';
import InsertVendors from '../../../../components/vendorComponent/insertVendor';
import { translate } from "react-i18next";
// import ReadAxios from '../../../components/axiosComponent/read';
import ReadVAxios from "../../../../components/axiosComponent/readV";
import { isEmpty } from 'lodash';

class Vendor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: localStorage.getItem('customerNumber') != 1158 ? "edit_vendor_title" : "edit_title",
            editData: {},
            rowData: [],
            loadingData: true,
            vendorid: ""
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.title) {
            console.log("this props is vendor props: ", this.props.location.state.title)
            this.setState({
                title: this.props.location.state.title,
                // editData: { ...this.props.location.state },
            });
        }
        console.log(this.props.location.state)
        this.state.vendorid = localStorage.getItem("vendorId");
        if (this.state.vendorid) {
            ReadVAxios({ url: `vendorDetails/` + this.state.vendorid })
                .then((dataArray) => {
                    console.log(dataArray);
                    isEmpty(dataArray)
                        ? this.setState({ loadingData: false, editData: {} })
                        : this.setState({ loadingData: false, editData: dataArray.data.resultSet });

                }, () => console.log("check eiditdata : ", this.state.editData))
                .catch((err) => {
                    console.log(err);
                    // this.setState({ loadingData: false, rowData: [] });
                });
        }

        // ReadAxios({ url: "users/vendor", readItems: { vendorId: this.props.location.state && this.props.location.state.transporterMasterId } })
        //     .then((dataArray) => {
        //         // console.log('...', dataArray.data.resultSet)
        //         isEmpty(dataArray)
        //             ? this.setState({ loadingData: false, rowData: [] })
        //             : this.setState({ loadingData: false, rowData: dataArray.data.resultSet });
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //         this.setState({ loadingData: false, rowData: [] });
        //     });
    }

    onFormSubmit = () => {
        // this.props.history.push("/vendor");
        // this.props.history.go();
        window.location.reload()
    };

    render() {
        const { t } = this.props;
        const { editData } = this.state;
        return (
            <React.Fragment>
                <AddTitleBar Title={t(this.state.title)} hideClose="true" />
                <div className="m-2">
                    <InsertVendors
                        editData={editData}
                        onFormSubmit={this.onFormSubmit}
                        // usersList={this.state.rowData}
                        action={this.state.title}
                    />
                    {console.info("Info about ", this.state)}
                </div>
            </React.Fragment>

        )
    }
}

export default translate("create_vendor")(Vendor);